(() => {
  let dialog, enlarged, caption, opener;
  const labels = document.querySelector('#gg-zoom-labels')?.dataset || {};
  function openImage(media, button) {
    const image = media.querySelector('img');
    if (!image) return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'image-zoom-dialog';
      dialog.setAttribute('aria-label', labels.title || 'Jewellery image detail');
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'image-zoom-close';
      close.textContent = labels.close || 'Close image';
      close.addEventListener('click', () => dialog.close());
      enlarged = document.createElement('img');
      caption = document.createElement('p');
      dialog.append(close, enlarged, caption);
      document.body.append(dialog);
      dialog.addEventListener('click', event => {
        if (event.target === dialog) {
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }
      });
      dialog.addEventListener('close', () => opener?.focus());
    }
    opener = button;
    enlarged.src = image.currentSrc || image.src;
    enlarged.alt = image.alt;
    caption.textContent = image.alt;
    dialog.showModal();
  }
  function enhance(root) {
    root.querySelectorAll('[data-image-zoom],.product-visual').forEach(media => {
      if (media.querySelector('.image-zoom-button') || !media.querySelector('img')) return;
      media.classList.add('image-zoom-media');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'image-zoom-button';
      button.textContent = labels.open || 'Zoom';
      button.setAttribute('aria-haspopup', 'dialog');
      button.addEventListener('click', () => openImage(media, button));
      media.append(button);
      media.addEventListener('pointermove', event => {
        if (event.pointerType !== 'mouse') return;
        const bounds = media.getBoundingClientRect();
        const x = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
        const y = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
        media.style.setProperty('--zoom-x', x + '%');
        media.style.setProperty('--zoom-y', y + '%');
      });
      media.addEventListener('pointerleave', () => {
        media.style.setProperty('--zoom-x', '50%');
        media.style.setProperty('--zoom-y', '50%');
      });
    });
  }
  enhance(document);
  const grid = document.querySelector('#product-grid');
  if (grid) new MutationObserver(() => enhance(grid)).observe(grid, { childList: true });
})();
